import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { Source } from "@finance/shared";

interface SourceBadgeProps {
  source: Source;
  className?: string;
}

export function SourceBadge({ source, className }: SourceBadgeProps) {
  const isApi = source === "api";
  return (
    <Badge
      variant={isApi ? "secondary" : "outline"}
      className={cn(
        "font-mono text-[10px] uppercase tracking-wide",
        isApi && "bg-accent/15 text-accent",
        className,
      )}
      title={isApi ? "Synced from an external API" : "Manually entered"}
    >
      {isApi ? "API" : "Manual"}
    </Badge>
  );
}
